// import { Alert, Divider, Snackbar } from '@mui/material'
// import path from 'path'
// import React, { useEffect, useState } from 'react'
// import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
// import Order from './Order'
// import UserDetails from './UserDetails'
// import SavedCards from './SavedCards'
// import OrderDetails from './OrderDetails'
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store'
// import { performLogout } from '../../../Redux Toolkit/Customer/AuthSlice'
// import userEvent from '@testing-library/user-event'
// import Addresses from './Adresses'

// const menu = [
//     { name: "Orders", path: "/account/orders" },
//     { name: "Profile", path: "/account/profile" },
//     // { name: "Saved Cards", path: "/account/saved-card" },

//     { name: "Addresses", path: "/account/addresses" },
//     { name: "Logout", path: "/" }
// ]
// const Profile = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const dispatch = useAppDispatch()
//     const { user,orders } = useAppSelector(store => store)
//     const [snackbarOpen, setOpenSnackbar] = useState(false);

//     const handleLogout = () => {
//         dispatch(performLogout())
//         navigate("/")
//     }

//     const handleClick = (item: any) => {
//         if (item.name === "Logout") {
//             handleLogout()
//         }
//         else navigate(`${item.path}`)
//     }
//     const handleCloseSnackbar = () => {
//         setOpenSnackbar(false);
//     };

//     useEffect(() => {
//         if (user.profileUpdated || orders.orderCanceled || user.error) {
//             setOpenSnackbar(true);
//         }
//     }, [user.profileUpdated,orders.orderCanceled]);
//     return (
//         <div className='px-5 lg:px-52 min-h-screen mt-10 '>

//             <div>
//                 <h1 className='text-xl font-bold pb-5'>{user.user?.fullName}</h1>
//             </div>
//             <Divider />
//             <div className='grid grid-cols-1 lg:grid-cols-3 lg:min-h-[78vh]'>

//                 <div className="col-span-1 lg:border-r lg:pr-5 py-5 h-full  flex flex-row flex-wrap lg:flex-col gap-3">

//                     {menu.map((item, index) => <div
//                         onClick={() => handleClick(item)}
//                         className={`${menu.length - 1 !== index ? "border-b" : ""} ${item.path == location.pathname ? "bg-primary-color text-white" : ""} px-5 py-3 rounded-md hover:bg-teal-500 hover:text-white cursor-pointer `}>
//                         <p>{item.name}</p>
//                     </div>)}

//                 </div>
//                 <div className='lg:col-span-2 lg:pl-5 py-5'>

//                     <Routes>
//                         <Route path='/' element={<UserDetails />} />
//                         <Route path='/orders' element={<Order />} />
//                         <Route path='/orders/:orderId/:orderItemId' element={<OrderDetails />} />
//                         <Route path='/profile' element={<UserDetails />} />
//                         {/* <Route path='/saved-card' element={<SavedCards />} /> */}
//                         <Route path='/addresses' element={<Addresses />} />
//                         {/* addresses */}
//                     </Routes>

//                 </div>

//             </div>
//             <Snackbar
//                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
//                 open={snackbarOpen}
//                 autoHideDuration={6000}
//                 onClose={handleCloseSnackbar}
//             >
//                 <Alert
//                     onClose={handleCloseSnackbar}
//                     severity={user.error ? "error" : "success"}
//                     variant="filled"
//                     sx={{ width: "100%" }}
//                 >
//                     {user.error ? user.error : orders.orderCanceled?"order canceled successfully": "success"}
//                 </Alert>
//             </Snackbar>
//         </div>
//     )
// }

// export default Profile


// Modern website

// import { Alert, Snackbar } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import { User, Package, MapPin, LogOut } from "lucide-react";

// import Order from "./Order";
// import UserDetails from "./UserDetails";
// import OrderDetails from "./OrderDetails";
// import Addresses from "./Adresses";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { performLogout } from "../../../Redux Toolkit/Customer/AuthSlice";

// const menu = [
//   {
//     name: "My Profile",
//     path: "/account/profile",
//     icon: User,
//   },
//   {
//     name: "Orders",
//     path: "/account/orders",
//     icon: Package,
//   },
//   {
//     name: "Addresses",
//     path: "/account/addresses",
//     icon: MapPin,
//   },
//   {
//     name: "Logout",
//     path: "/",
//     icon: LogOut,
//   },
// ];

// const Profile = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useAppDispatch();

//   const { user, orders } = useAppSelector((store) => store);

//   const [snackbarOpen, setOpenSnackbar] = useState(false);

//   const handleLogout = () => {
//     dispatch(performLogout());
//     navigate("/");
//   };

//   const handleClick = (item: any) => {
//     if (item.name === "Logout") {
//       handleLogout();
//     } else {
//       navigate(item.path);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//   };

//   useEffect(() => {
//     if (user.profileUpdated || orders.orderCanceled || user.error) {
//       setOpenSnackbar(true);
//     }
//   }, [user.profileUpdated, orders.orderCanceled, user.error]);

//   return (
//     <div className="min-h-screen bg-white px-4 sm:px-6 lg:px-10 xl:px-16 py-6">
//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 max-w-[1400px] mx-auto">
//         <aside className="lg:col-span-1">
//           <div className="lg:sticky lg:top-24 space-y-5">
//             <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-3">
//               <div className="pb-4 mb-3 border-b border-gray-200 px-3">
//                 <h2 className="text-lg font-semibold text-gray-900">
//                   My Account
//                 </h2>
//                 <p className="text-sm text-gray-500 truncate">
//                   {user.user?.fullName || "Welcome"}
//                 </p>
//               </div>

//               <div className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-1 lg:pb-0">
//                 {menu.map((item) => {
//                   const Icon = item.icon;
//                   const isActive =
//                     item.path === location.pathname ||
//                     (item.path === "/account/profile" &&
//                       location.pathname === "/account");

//                   return (
//                     <button
//                       key={item.name}
//                       onClick={() => handleClick(item)}
//                       className={`
//                         min-w-max lg:min-w-0 w-full
//                         flex items-center gap-3
//                         px-4 py-3 rounded-xl
//                         text-sm font-medium
//                         transition-all
//                         ${
//                           isActive
//                             ? "bg-gray-100 text-primary-color"
//                             : "text-gray-700 hover:bg-gray-100 hover:text-primary-color"
//                         }
//                       `}
//                     >
//                       <Icon size={18} />
//                       <span>{item.name}</span>
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="hidden lg:block bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
//               <p className="font-semibold text-gray-900">Need Help?</p>
//               <p className="text-sm text-gray-500 mt-1">
//                 We’re here to help you.
//               </p>

//               <button
//                 onClick={() => navigate("/contact")}
//                 className="mt-4 w-full border border-primary-color text-primary-color rounded-lg py-2 text-sm font-medium hover:bg-gray-100 transition"
//               >
//                 Contact Us
//               </button>
//             </div>
//           </div>
//         </aside>

//         <main className="lg:col-span-3 min-w-0">
//           <Routes>
//             <Route path="/" element={<UserDetails />} />
//             <Route path="/profile" element={<UserDetails />} />
//             <Route path="/orders" element={<Order />} />
//             <Route
//               path="/orders/:orderId/:orderItemId"
//               element={<OrderDetails />}
//             />
//             <Route path="/addresses" element={<Addresses />} />
//           </Routes>
//         </main>
//       </div>

//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={user.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {user.error
//             ? user.error
//             : orders.orderCanceled
//             ? "Order canceled successfully"
//             : "Success"}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default Profile;



// import { Alert, Snackbar } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import { User, Package, MapPin, LogOut } from "lucide-react";

// import Order from "./Order";
// import UserDetails from "./UserDetails";
// import OrderDetails from "./OrderDetails";
// import Addresses from "./Adresses";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { performLogout } from "../../../Redux Toolkit/Customer/AuthSlice";

// const menu = [
//   {
//     name: "My Profile",
//     path: "/account/profile",
//     icon: User,
//   },
//   {
//     name: "Orders",
//     path: "/account/orders",
//     icon: Package,
//   },
//   {
//     name: "Addresses",
//     path: "/account/addresses",
//     icon: MapPin,
//   },
//   {
//     name: "Logout",
//     path: "/",
//     icon: LogOut,
//   },
// ];

// const Profile = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useAppDispatch();

//   const { user, orders } = useAppSelector((store) => store);

//   const [snackbarOpen, setOpenSnackbar] = useState(false);

//   const handleLogout = () => {
//     dispatch(performLogout());
//     navigate("/");
//   };

//   const handleClick = (item: any) => {
//     if (item.name === "Logout") {
//       handleLogout();
//     } else {
//       navigate(item.path);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//   };

//   useEffect(() => {
//     if (user.profileUpdated || orders.orderCanceled || user.error) {
//       setOpenSnackbar(true);
//     }
//   }, [user.profileUpdated, orders.orderCanceled, user.error]);

//   return (
//     <div className="min-h-screen bg-white px-4 sm:px-6 lg:px-10 xl:px-16 py-6">
//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 max-w-[1400px] mx-auto">
//         <aside className="lg:col-span-1">
//           <div className="lg:sticky lg:top-24 space-y-5">
//             <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-3">
//               <div className="hidden lg:block pb-4 mb-3 border-b border-gray-200 px-3">
//                 <h2 className="text-lg font-semibold text-gray-900">
//                   My Account
//                 </h2>
//                 <p className="text-sm text-gray-500 truncate">
//                   {user.user?.fullName || "Welcome"}
//                 </p>
//               </div>

//               <div className="grid grid-cols-4 lg:flex lg:flex-col gap-2">
//                 {menu.map((item) => {
//                   const Icon = item.icon;
//                   const isActive =
//                     item.path === location.pathname ||
//                     (item.path === "/account/profile" &&
//                       location.pathname === "/account");

//                   return (
//                     <button
//                       key={item.name}
//                       onClick={() => handleClick(item)}
//                       className={`
//                         w-full
//                         flex flex-col lg:flex-row items-center justify-center lg:justify-start
//                         gap-2 lg:gap-3
//                         px-3 py-4 lg:px-4 lg:py-3
//                         rounded-xl
//                         text-sm font-medium
//                         transition-all
//                         border lg:border-0
//                         ${
//                           isActive
//                             ? "bg-gray-100 text-primary-color border-gray-200"
//                             : "text-gray-700 border-gray-200 hover:bg-gray-100 hover:text-primary-color"
//                         }
//                       `}
//                     >
//                       <Icon size={20} className="lg:w-[18px] lg:h-[18px]" />
//                       <span>{item.name}</span>
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="hidden lg:block bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
//               <p className="font-semibold text-gray-900">Need Help?</p>
//               <p className="text-sm text-gray-500 mt-1">
//                 We’re here to help you.
//               </p>

//               <button
//                 onClick={() => navigate("/contact")}
//                 className="mt-4 w-full border border-primary-color text-primary-color rounded-lg py-2 text-sm font-medium hover:bg-gray-100 transition"
//               >
//                 Contact Us
//               </button>
//             </div>
//           </div>
//         </aside>

//         <main className="lg:col-span-3 min-w-0">
//           <Routes>
//             <Route path="/" element={<UserDetails />} />
//             <Route path="/profile" element={<UserDetails />} />
//             <Route path="/orders" element={<Order />} />
//             <Route
//               path="/orders/:orderId/:orderItemId"
//               element={<OrderDetails />}
//             />
//             <Route path="/addresses" element={<Addresses />} />
//           </Routes>
//         </main>
//       </div>

//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={user.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {user.error
//             ? user.error
//             : orders.orderCanceled
//             ? "Order canceled successfully"
//             : "Success"}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default Profile;



// import { Alert, Snackbar } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import { User, Package, MapPin, LogOut } from "lucide-react";

// import Order from "./Order";
// import UserDetails from "./UserDetails";
// import OrderDetails from "./OrderDetails";
// import Addresses from "./Adresses";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { performLogout } from "../../../Redux Toolkit/Customer/AuthSlice";

// const menu = [
//   { name: "My Profile", path: "/account/profile", icon: User },
//   { name: "Orders", path: "/account/orders", icon: Package },
//   { name: "Addresses", path: "/account/addresses", icon: MapPin },
//   { name: "Logout", path: "/", icon: LogOut },
// ];

// const Profile = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useAppDispatch();

//   const { user, orders } = useAppSelector((store) => store);
//   const [snackbarOpen, setOpenSnackbar] = useState(false);

//   const handleLogout = () => {
//     dispatch(performLogout());
//     navigate("/");
//   };

//   const handleClick = (item: any) => {
//     if (item.name === "Logout") handleLogout();
//     else navigate(item.path);
//   };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//   };

//   useEffect(() => {
//     if (user.profileUpdated || orders.orderCanceled || user.error) {
//       setOpenSnackbar(true);
//     }
//   }, [user.profileUpdated, orders.orderCanceled, user.error]);

//   return (
//     <div className="min-h-screen bg-white px-4 sm:px-6 lg:px-10 xl:px-16 py-6">
//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 max-w-[1400px] mx-auto">
//         <aside className="lg:col-span-1">
//           <div className="lg:sticky lg:top-24 space-y-5">
//             <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-3">
//               <div className="hidden lg:block pb-4 mb-3 border-b border-gray-200 px-3">
//                 <h2 className="text-lg font-semibold text-gray-900">
//                   My Account
//                 </h2>
//                 <p className="text-sm text-gray-500 truncate">
//                   {user.user?.fullName || "Welcome"}
//                 </p>
//               </div>

//               <div className="grid grid-cols-4 lg:flex lg:flex-col gap-2">
//                 {menu.map((item) => {
//                   const Icon = item.icon;
//                   const isActive =
//                     item.path === location.pathname ||
//                     (item.path === "/account/profile" &&
//                       location.pathname === "/account");

//                   return (
//                     <button
//                       key={item.name}
//                       onClick={() => handleClick(item)}
//                       className={`
//                         w-full
//                         flex flex-col lg:flex-row items-center justify-center lg:justify-start
//                         gap-1.5 lg:gap-3
//                         px-2 py-3 lg:px-4 lg:py-3
//                         rounded-xl
//                         text-[11px] sm:text-sm font-medium
//                         transition-all
//                         border lg:border-0
//                         ${
//                           isActive
//                             ? "bg-gray-100 text-primary-color border-gray-200"
//                             : "text-gray-700 border-gray-200 hover:bg-gray-100 hover:text-primary-color"
//                         }
//                       `}
//                     >
//                       <Icon size={18} className="w-5 h-5 lg:w-[18px] lg:h-[18px]" />
//                       <span className="whitespace-nowrap">{item.name}</span>
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="hidden lg:block bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
//               <p className="font-semibold text-gray-900">Need Help?</p>
//               <p className="text-sm text-gray-500 mt-1">
//                 We’re here to help you.
//               </p>

//               <button
//                 onClick={() => navigate("/contact")}
//                 className="mt-4 w-full border border-primary-color text-primary-color rounded-lg py-2 text-sm font-medium hover:bg-gray-100 transition"
//               >
//                 Contact Us
//               </button>
//             </div>
//           </div>
//         </aside>

//         <main className="lg:col-span-3 min-w-0">
//           <Routes>
//             <Route path="/" element={<UserDetails />} />
//             <Route path="/profile" element={<UserDetails />} />
//             <Route path="/orders" element={<Order />} />
//             <Route
//               path="/orders/:orderId/:orderItemId"
//               element={<OrderDetails />}
//             />
//             <Route path="/addresses" element={<Addresses />} />
//           </Routes>
//         </main>
//       </div>

//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={user.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {user.error
//             ? user.error
//             : orders.orderCanceled
//             ? "Order canceled successfully"
//             : "Success"}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default Profile;



import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { User, Package, MapPin, LogOut } from "lucide-react";

import Order from "./Order";
import UserDetails from "./UserDetails";
import OrderDetails from "./OrderDetails";
import Addresses from "./Adresses";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { performLogout } from "../../../Redux Toolkit/Customer/AuthSlice";

const menu = [
  { name: "My Profile", path: "/account/profile", icon: User },
  { name: "Orders", path: "/account/orders", icon: Package },
  { name: "Addresses", path: "/account/addresses", icon: MapPin },
  { name: "Logout", path: "/", icon: LogOut },
];

const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { user, orders } = useAppSelector((store) => store);
  const [snackbarOpen, setOpenSnackbar] = useState(false);

  const isOrderDetailPage = /^\/account\/orders\/[^/]+\/[^/]+$/.test(
    location.pathname
  );

  const handleLogout = () => {
    dispatch(performLogout());
    navigate("/");
  };

  const handleClick = (item: any) => {
    if (item.name === "Logout") handleLogout();
    else navigate(item.path);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (user.profileUpdated || orders.orderCanceled || user.error) {
      setOpenSnackbar(true);
    }
  }, [user.profileUpdated, orders.orderCanceled, user.error]);

  return (
    <div className="min-h-screen bg-white px-4 sm:px-6 lg:px-10 xl:px-16 py-6">
      <div
        className={`max-w-[1400px] mx-auto ${
          isOrderDetailPage
            ? "block"
            : "grid grid-cols-1 lg:grid-cols-4 gap-6"
        }`}
      >
        {!isOrderDetailPage && (
          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-24 space-y-5">
              <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-3">
                <div className="hidden lg:block pb-4 mb-3 border-b border-gray-200 px-3">
                  <h2 className="text-lg font-semibold text-gray-900">
                    My Account
                  </h2>
                  <p className="text-sm text-gray-500 truncate">
                    {user.user?.fullName || "Welcome"}
                  </p>
                </div>

                <div className="grid grid-cols-4 lg:flex lg:flex-col gap-2">
                  {menu.map((item) => {
                    const Icon = item.icon;
                    const isActive =
                      item.path === location.pathname ||
                      (item.path === "/account/profile" &&
                        location.pathname === "/account");

                    return (
                      <button
                        key={item.name}
                        onClick={() => handleClick(item)}
                        className={`
                          w-full
                          flex flex-col lg:flex-row items-center justify-center lg:justify-start
                          gap-1.5 lg:gap-3
                          px-2 py-3 lg:px-4 lg:py-3
                          rounded-xl
                          text-[11px] sm:text-sm font-medium
                          transition-all
                          border lg:border-0
                          ${
                            isActive
                              ? "bg-gray-100 text-primary-color border-gray-200"
                              : "text-gray-700 border-gray-200 hover:bg-gray-100 hover:text-primary-color"
                          }
                        `}
                      >
                        <Icon
                          size={18}
                          className="w-5 h-5 lg:w-[18px] lg:h-[18px]"
                        />
                        <span className="whitespace-nowrap">{item.name}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="hidden lg:block bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
                <p className="font-semibold text-gray-900">Need Help?</p>
                <p className="text-sm text-gray-500 mt-1">
                  We’re here to help you.
                </p>

                <button
                  onClick={() => navigate("/contact")}
                  className="mt-4 w-full border border-primary-color text-primary-color rounded-lg py-2 text-sm font-medium hover:bg-gray-100 transition"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </aside>
        )}

        <main className={isOrderDetailPage ? "w-full min-w-0" : "lg:col-span-3 min-w-0"}>
          <Routes>
            <Route path="/" element={<UserDetails />} />
            <Route path="/profile" element={<UserDetails />} />
            <Route path="/orders" element={<Order />} />
            <Route
              path="/orders/:orderId/:orderItemId"
              element={<OrderDetails />}
            />
            <Route path="/addresses" element={<Addresses />} />
          </Routes>
        </main>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={user.error ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {user.error
            ? user.error
            : orders.orderCanceled
            ? "Order canceled successfully"
            : "Success"}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Profile;